import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFIconProps } from './IconProps'

export function ReportIcon(iconProps: EFIconProps) {
  const isDark = useAppSelector(isDarkTheme)

  const fill = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'

  return (
    <svg
      width={iconProps.width}
      height={iconProps.height}
      viewBox={`0 -3 23 34`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.0322 13.3734C7.0322 12.7912 6.56023 12.3192 5.97803 12.3192C5.39583 12.3192 4.92386 12.7912 4.92386 13.3734V23.2123C4.92386 23.7945 5.39583 24.2665 5.97803 24.2665C6.56023 24.2665 7.0322 23.7945 7.0322 23.2123V13.3734Z'
        fill={fill}
      />
      <path
        d='M11.9517 16.1845C11.9517 15.6023 11.4797 15.1303 10.8975 15.1303C10.3153 15.1303 9.84333 15.6023 9.84333 16.1845V23.2123C9.84333 23.7945 10.3153 24.2665 10.8975 24.2665C11.4797 24.2665 11.9517 23.7945 11.9517 23.2123V16.1845Z'
        fill={fill}
      />
      <path
        d='M16.8711 18.9956C16.8711 18.4134 16.3992 17.9415 15.817 17.9415C15.2348 17.9415 14.7628 18.4134 14.7628 18.9956V23.2123C14.7628 23.7945 15.2348 24.2665 15.817 24.2665C16.3992 24.2665 16.8711 23.7945 16.8711 23.2123V18.9956Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.8281 1.54696L22.0211 9.73858C22.5482 10.2657 22.8448 10.9811 22.8448 11.7261V26.0234C22.8448 27.5752 21.5854 28.8346 20.0337 28.8346H3.1669C1.61516 28.8346 0.355774 27.5752 0.355774 26.0234V3.53442C0.355774 1.98268 1.61516 0.723297 3.1669 0.723297H11.842C11.8812 0.723297 11.9195 0.728513 11.9576 0.733711C11.9851 0.737464 12.0125 0.741207 12.0402 0.742975C12.3424 0.764058 12.6404 0.821687 12.9173 0.936943C12.9979 0.971344 13.0744 1.01561 13.1506 1.05969C13.174 1.07324 13.1974 1.08677 13.2209 1.09999C13.2426 1.11189 13.2651 1.12284 13.2877 1.13382C13.3264 1.15266 13.3653 1.17159 13.4008 1.19557C13.5104 1.27006 13.6088 1.35861 13.7086 1.44857C13.7248 1.4629 13.7421 1.47622 13.7596 1.4896C13.7833 1.50771 13.8071 1.52594 13.8281 1.54696ZM20.0337 26.7262C20.4216 26.7262 20.7364 26.41 20.7364 26.0234V11.9678H14.4114C12.8597 11.9678 11.6003 10.7084 11.6003 9.15668V2.83164H3.1669C2.77897 2.83164 2.46412 3.14789 2.46412 3.53442V26.0234C2.46412 26.41 2.77897 26.7262 3.1669 26.7262H20.0337ZM19.1594 9.85946L13.7086 4.40728V9.15668C13.7086 9.54321 14.0235 9.85946 14.4114 9.85946H19.1594Z'
        fill={fill}
      />
    </svg>
  )
}
